import { useTranslation } from 'react-i18next';

import { Modal } from '@app/shared/ui/organisms/Common';
import { Heading } from '@app/shared/ui/atoms/Common';
import { ModalText } from '@app/shared/ui/molecules/Shop';
import { ShopModalType } from '@app/shared/types/pages/shop';
import { eatingPandaImage, cottageImage, pandaWithCardImage, richPandaImage } from '@app/assets';

export interface ShopModalProps {
  type: ShopModalType;
  isOpen: boolean;
  onOpenChange: () => void;
}

const MODALS = {
  'magic-cookies': {
    title: 'shop.magic_cookies',
    background: 'bg-accent',
    image: eatingPandaImage,
    imageBackgroundVariant: 'blue',
    alt: 'eating-panda',
    translationKeys: ['cookies_desc_1', 'cookies_desc_2'],
  },
  'energy-stones': {
    title: 'shop.energy_stones',
    background: 'bg-accent',
    image: richPandaImage,
    imageBackgroundVariant: 'blue',
    alt: 'rich-panda',
    translationKeys: ['stones_desc_1', 'stones_desc_2'],
  },
  settlements: {
    title: 'shop.settlements',
    background: 'bg-orange-400',
    image: cottageImage,
    imageBackgroundVariant: 'orange',
    alt: 'cottage',
    translationKeys: ['settlements_desc_1', 'settlements_desc_2'],
  },
  'pandora-bank': {
    title: 'shop.pandora_bank',
    background: 'bg-accent',
    image: pandaWithCardImage,
    imageBackgroundVariant: 'blue',
    alt: 'panda-with-card',
    translationKeys: ['bank_desc_1', 'bank_desc_2'],
  },
} as const;

export const ShopModal = ({ isOpen, onOpenChange, type }: ShopModalProps) => {
  const { t } = useTranslation();
  const modal = MODALS[type];
  const translationKeys = modal.translationKeys.map((key) => `shop.modals.${key}`);

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      featuredImg={<img src={modal.image} alt={modal.alt} className="size-36 object-contain" />}
      featuredImgBackgroundVariant={modal.imageBackgroundVariant}
      contentClassName={modal.background}
      hiddenTitle={t(modal.title)}
    >
      <Heading level={2} className="text-foreground">
        {t(modal.title)}
      </Heading>
      <ModalText translationKeys={translationKeys} />
    </Modal>
  );
};
